@if (isActive) {
  <topo-modal
    [isActive]="isActive"
    [backgroundCanClose]="true"
    [isCard]="true"
    [width]="800">
    <div class="modal-header">
      <div
        fxLayout="row"
        fxLayoutAlign="space-between center">
        <h5 class="mx-4 my-4">
          {{ 'FILTERS.PROXIMITY-FILTER-SETTINGS' | translate }}
        </h5>
        <div
          class="dialog-close"
          (click)="cancelClick()">
          <i class="icon icon-close-X"></i>
        </div>
      </div>
    </div>
    <div
      class="modal-body"
      style="width: 100%">
      <div class="field">
        <label>
          {{
            'FILTERS.DEFAULT-DISTANCE-UNIT'
              | translate
                : { unit: (isUserDistanceInKilometers ? 'UNITS.DISTANCE.KILOMETERS-CAMEL' : 'UNITS.DISTANCE.MILES-CAMEL') | translate }
          }}
        </label>
        <div>
          <input
            type="number"
            class="input is-medium"
            [(ngModel)]="proximityValue" />
        </div>
      </div>
      @if (hasDatasets) {
        <div class="field">
          <label>{{ 'FILTERS.DATASET-TYPE' | translate }}</label>
          <div>
            <div class="select is-secondary is-medium">
              <select
                [(ngModel)]="selectedDatasetType"
                (change)="datasetTypeChanged()">
                @for (datasetType of datasetTypes; track datasetType.value) {
                  <option [ngValue]="datasetType.value">
                    {{ datasetType.name }}
                  </option>
                }
              </select>
            </div>
          </div>
        </div>
      }
      @if (hasDatasets) {
        <div class="field">
          <label>{{ 'FILTERS.DATASET' | translate }}</label>
          <div>
            <div class="select is-secondary is-medium">
              <select
                [(ngModel)]="selectedDatasetUId"
                (change)="datasetChanged($event)">
                @for (dataset of datasets; track dataset.uId) {
                  <option [ngValue]="dataset.uId">
                    {{ dataset.name }}
                  </option>
                }
              </select>
            </div>
          </div>
        </div>
      }
      @if (hasDatasets) {
        <div class="field">
          <label>
            {{ 'FILTERS.GEOMETRY-FIELD' | translate }}
          </label>
          <div>
            <div class="select is-secondary is-medium">
              <select [(ngModel)]="selectedField">
                @for (field of geoFields; track field.systemName) {
                  <option [ngValue]="field.systemName">
                    {{ field.displayName }}
                  </option>
                }
              </select>
            </div>
          </div>
        </div>
      }
      <topo-filter-display
        [disabled]="!(schema?.fields?.length > 0)"
        [schema]="schema"
        [filterGroup]="filterGroup"
        [workflow]="filterWorkflow"
        actionIfDescription="FILTERS.PREFIX.IF"
        actionResultDescription="FILTERS.POSTFIX.ITEMS"
        (filterChanged)="filterChanged($event)"
        [maxLength]="175"></topo-filter-display>
    </div>
    <div class="modal-footer">
      <div
        fxLayout="row"
        fxLayoutAlign="end"
        class="mt-4 mb-4">
        <div style="margin-right: 5px">
          <button
            class="button is-secondary"
            (click)="cancelClick()">
            {{ 'FILTERS.CANCEL' | translate }}
          </button>
        </div>
        <div>
          <button
            class="button is-primary"
            (click)="saveClick()">
            {{ 'FILTERS.SAVE' | translate }}
          </button>
        </div>
      </div>
    </div>
  </topo-modal>
}
